module.exports = __webpack_public_path__ + "img/1.3b71d6d8.png";